import { IActimoDistributionDeletion } from '@admin/settings/distribution-channels/delete-distribution-dialog/delete-distribution-channel-dialog.component';

export type SettingsKeyType = { [key in SETTINGS_KEYS]: string };

export enum SETTINGS_KEYS {
  UTM_TAGS = 'utm_tagging_enabled',
  GLOBAL_UTM_TAGS = 'global_utm_tags',
  MYHUB_APPEARANCE = 'myhub_appearance',
}

export const SettingsKeysMapping: SettingsKeyType = {
  [SETTINGS_KEYS.UTM_TAGS]: 'utm_tagging_enabled',
  [SETTINGS_KEYS.GLOBAL_UTM_TAGS]: 'global_utm_tags',
  [SETTINGS_KEYS.MYHUB_APPEARANCE]: 'myhub_appearance',
};

export interface IMyHubAppearanceServer {
  colour: string;
  // Null clears the cover photo - `removeCoverPhoto` relies on this being sent through.
  cover_photo_url: string | null;
  transparent_header: boolean;
}

export interface IMyHubAppearance {
  color: string;
  coverPhotoUrl: string | null;
  transparentHeader: boolean;
}

// The update endpoint takes multipart/form-data and receives the cover photo as a binary
// file rather than a URL - the backend uploads it to S3 and returns the URL on the next read.
// removeCoverPhoto clears the stored cover photo when the user removes it without picking a
// replacement (omitting the file alone is not enough - the backend keeps the existing one).
export interface IMyHubAppearanceUpdate {
  color: string;
  coverPhoto: File | null;
  removeCoverPhoto: boolean;
  transparentHeader: boolean;
}

export interface ICompanyInfo {
  name: string;
  logo: string;
}

export interface IDeleteChannel extends IActimoDistributionDeletion {
  id: number;
}

export interface ISettingsServer {
  key: string;
  value: string;
  data_type: string;
  is_locked: boolean;
  default_value: any;
  updated_at: string;
  is_default: boolean;
}

export interface ISettings {
  key: string;
  value: any;
  dataType: string;
  isLocked: boolean;
  defaultValue: any;
  updatedAt: string;
  isDefault: boolean;
}
